var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"content"},[_c('side-nav'),_vm._t("default")],2),_c('Footer'),(!this.isModalOpen('notificationModal'))?_c('bottom-menu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }